/**
 * @module builder
 */
import type { QuoteDocument, OptionsDocument } from 'paintscout'

import type { UpdateableItem } from '../../index'

import { findItem } from './find-item'

export function findItems(args: { quote: QuoteDocument; options?: OptionsDocument; keys: string[] }): UpdateableItem[] {
  const { quote, options, keys } = args

  return keys.map((key: string) => {
    return findItem({ quote, options, key })
  })
}
